import getters from './getters';
import actions from './actions';
import mutations from './mutations';

var state = () => ({
  total: null,
  products: null,
  description: null
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};